import { useEffect, useState } from "react";
import DataTable from "../../../components/Reusables/DataTable/DataTable";
import "../../../assets/css/BlockRackTable/blockRackTable.css";

const columns = [
  { label: "LPN", key: "lpn", enableSortSearch: true },
  { label: "Item", key: "sku", enableSortSearch: true },
  { label: "Item Type", key: "itemType", enableSortSearch: true },
  { label: "Quantity", key: "quantity", enableSortSearch: true },
  { label: "Lot", key: "lot", enableSortSearch: true },
  { label: "Production Date", key: "productionDate", enableSortSearch: true },
  { label: "Expiration Date", key: "expirationDate", enableSortSearch: true },
  { label: "Position", key: "position", enableSortSearch: false },
  { label: "Row", key: "row", enableSortSearch: false },
  { label: "Level", key: "level", enableSortSearch: false },
];

const NonLGVInventoryTable = ({
  selectedInventoryData,
  updateNonLgvExportData,
  setClearFiltersFn,
  setShowClearFilter,
}) => {
  const [inventoryData, setInventoryData] = useState(selectedInventoryData);

  useEffect(() => {
    setInventoryData(selectedInventoryData);
  }, [selectedInventoryData]);

  if (!inventoryData) {
    return (
      <div className="table-loader">
        <h4>Loading...</h4>
        <div className="table-spinner"></div>
      </div>
    );
  }

  return (
    <DataTable
      dataTestID="non-lgv-block-table"
      id="block-location-table-block-rack-hof"
      columns={columns}
      data={inventoryData}
      updateNonLgvExportData={updateNonLgvExportData}
      setClearFiltersFn={setClearFiltersFn}
      setShowClearFilter={setShowClearFilter}
    />
  );
};
export default NonLGVInventoryTable;
